module.exports = __webpack_public_path__ + "static/media/20210403_204128_476_IMG_0001.996707d3.jpg";